import { faFacebookF, faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const SocialStickySidebar = () => {
    return <div className="social-sticky-sidebar fixed">
        <a href="https://jp.linkedin.com/company/lnet-learning-technologies-ltd" target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faLinkedinIn} />
        </a>
        <div className="hr"></div>
        <a href="https://www.facebook.com/LnetDigitallearning/" target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faFacebookF} />
        </a>

    </div>
}
export default SocialStickySidebar;